export enum ExpressionType {
	animationNames = 'animationNames',
	arg = 'arg',
	argc = 'argc',
	bbox = 'bbox',
	blob = 'blob',
	cameraName = 'cameraName',
	cameraNames = 'cameraNames',
	camerasCount = 'camerasCount',
	centroid = 'centroid',
	ch = 'ch',
	chsop = 'chsop',
	copy = 'copy',
	copRes = 'copRes',
	isDeviceMobile = 'isDeviceMobile',
	isDeviceTouch = 'isDeviceTouch',
	len = 'len',
	join = 'join',
	js = 'js',
	object = 'object',
	objectsCount = 'objectsCount',
	objectName = 'objectName',
	objectNames = 'objectNames',
	opdigits = 'opdigits',
	opname = 'opname',
	padzero = 'padzero',
	playerMode = 'playerMode',
	point = 'point',
	pointsCount = 'pointsCount',
	smoothstep = 'smoothstep',
	smootherstep = 'smootherstep',
	solverIteration = 'solverIteration',
	strCharsCount = 'strCharsCount',
	strConcat = 'strConcat',
	strIndex = 'strIndex',
	strSub = 'strSub',
	viewerSize = 'viewerSize',
	windowSize = 'windowSize',
}
